import { render, staticRenderFns } from "./taxonomy-data.vue?vue&type=template&id=4690b948&"
import script from "./taxonomy-data.vue?vue&type=script&lang=js&"
export * from "./taxonomy-data.vue?vue&type=script&lang=js&"
import style0 from "./taxonomy-data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports